import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pb-2 mt-2 rounded-xl",
  style: {"background":"#fff"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "d-flex justify-center align-center pt-3 pb-1"
    }, {
      default: _withCtx(() => _cache[13] || (_cache[13] = [
        _createElementVNode("b", null, "Informations déclarant", -1)
      ])),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "d-flex justify-center align-center py-1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "11" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field_filled, {
              disabled: _ctx.isSent,
              outlined: "",
              dense: "",
              "hide-details": "",
              label: "Code Insee commune",
              modelValue: _ctx.declaring.cityInseeCode,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.declaring.cityInseeCode) = $event)),
                _cache[1] || (_cache[1] = ($event: any) => (_ctx.declaringHasBeenChanged()))
              ]
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "d-flex justify-center align-center py-1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "11" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field_filled, {
              disabled: _ctx.isSent,
              outlined: "",
              dense: "",
              "hide-details": "",
              label: "Bureau distributeur",
              modelValue: _ctx.declaring.postOfficeDistributor,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.declaring.postOfficeDistributor) = $event)),
                _cache[3] || (_cache[3] = ($event: any) => (_ctx.declaringHasBeenChanged()))
              ]
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "d-flex justify-center align-center py-1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "11" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field_filled, {
              disabled: _ctx.isSent,
              outlined: "",
              dense: "",
              "hide-details": "",
              label: "Catégorie juridique",
              modelValue: _ctx.declaring.legalCategory,
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = ($event: any) => ((_ctx.declaring.legalCategory) = $event)),
                _cache[6] || (_cache[6] = ($event: any) => (_ctx.declaringHasBeenChanged()))
              ],
              "append-inner-icon": !_ctx.declaring.legalCategory && !_ctx.isSent && '$oss-help',
              "onClick:appendInner": _cache[5] || (_cache[5] = ($event: any) => (_ctx.openExternalLink()))
            }, null, 8, ["disabled", "modelValue", "append-inner-icon"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "d-flex justify-center align-center py-1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "11" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field_filled, {
              disabled: _ctx.isSent,
              outlined: "",
              dense: "",
              "hide-details": "",
              label: "Nom et prénom contact",
              modelValue: _ctx.declaring.name,
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = ($event: any) => ((_ctx.declaring.name) = $event)),
                _cache[8] || (_cache[8] = ($event: any) => (_ctx.declaringHasBeenChanged()))
              ]
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "d-flex justify-center align-center py-1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "11" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field_filled, {
              disabled: _ctx.isSent,
              outlined: "",
              dense: "",
              "hide-details": "",
              label: "Téléphone contact",
              modelValue: _ctx.declaring.phone,
              "onUpdate:modelValue": [
                _cache[9] || (_cache[9] = ($event: any) => ((_ctx.declaring.phone) = $event)),
                _cache[10] || (_cache[10] = ($event: any) => (_ctx.declaringHasBeenChanged()))
              ]
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "d-flex justify-center align-center py-1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "11" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field_filled, {
              disabled: _ctx.isSent,
              outlined: "",
              dense: "",
              "hide-details": "",
              label: "Email contact",
              modelValue: _ctx.declaring.email,
              "onUpdate:modelValue": [
                _cache[11] || (_cache[11] = ($event: any) => ((_ctx.declaring.email) = $event)),
                _cache[12] || (_cache[12] = ($event: any) => (_ctx.declaringHasBeenChanged()))
              ]
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}